<template>
  <div>
    <!-- 头和底公用 -->
    <v-header />
    <div class="viewmain">
      <div class="viewmain-container">
        <router-view />
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/layout/P.vue